// Libraries
import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery, useQueryClient } from '@tanstack/react-query';

// API
import { fetchBatches } from 'api/admin/businesses/businesses';
import { useRetriggerInitializationForStores } from 'api/queries/useRetriggerInitializationForStores';

// Components
import { Header } from './Header';
import { Batches } from './Batches';
import CentsLoader from 'components/common/centsLoader/CentsLoader';

const BusinessDevices = ({ stores }) => {
  const queryClient = useQueryClient();
  const { id: businessOwnerId } = useParams();
  const queryKey = ['batches', businessOwnerId];

  const { data: batches, isLoading: isBatchesLoading, error } = useQuery(
    queryKey,
    () => fetchBatches(businessOwnerId),
  );

  const batchesError = error?.response?.data?.error ?? error?.message ?? '';

  const refetchBatches = () => queryClient.invalidateQueries({ queryKey });

  const businessOwner = batches?.data?.businessOwner ?? null;
  const batchList = batches?.data?.batchList ?? [];

  const {
    isFetching: isInitializingDevices,
    retriggerInitialization: onRetriggerInitialization,
  } = useRetriggerInitializationForStores({ storeIds: stores.map((store) => store.id) });

  const handleInitializationTrigger = () => {
    if (batchList.length) {
      onRetriggerInitialization();
    }
  };

  return (
    <div className='page-container'>
      {isInitializingDevices && <CentsLoader />}
      <Header
        businessOwner={businessOwner}
        businessOwnerId={businessOwnerId}
        refetchBatches={refetchBatches}
        reinitializeDevices={handleInitializationTrigger}
        batchCount={batchList.length}
        stores={stores}
      />
      <Batches
        batchList={batchList}
        businessOwner={businessOwner}
        deviceError={batchesError}
        isBatchesLoading={isBatchesLoading}
      />
    </div>
  );
};

export default BusinessDevices;
